/**
 * What each report table actually means, in the words of the people who use it.
 *
 * The report schema gives a name, a label and column types, and that is not enough to reason with: it
 * does not say whether an amount is the whole invoice or one instalment, whether a date is when
 * something was due or when it happened, or which table you should be counting. The AI report builder
 * gets these sentences alongside the schema.
 *
 * Written here rather than derived on the server for the same reason capabilities are written next to
 * the components they describe: whoever changes what a table means is looking at this app.
 *
 * A table with no entry is not a problem - the builder falls back to the grain it works out from the
 * table's own identifiers ("one row per patient cost share invoice"). Add an entry when a name is
 * genuinely misleading, or when there is something a reader could not guess.
 */
const REPORT_TABLE_DESCRIPTIONS = {
  PatientCostShareInvoiceReportView:
    "One cost share invoice per row: what a patient was billed for a period, what has been paid " +
    "against it and what is still outstanding. A patient has many of these, so a per-patient total " +
    "has to be summed.",
  PatientCostSharePaymentReportView:
    "One received payment per row, with the date it came in and the amount. A payment belongs to a " +
    "patient rather than to a single invoice, and a reversed payment keeps a reversal date.",
  PatientCostShareScheduleReportView:
    "The standing arrangement rather than the money: how much a patient is due to pay and how often, " +
    "with the dates the arrangement runs between. One row per schedule, and a patient may have had " +
    "several over time."
};

export function describeReportTable(tableName) {
  return REPORT_TABLE_DESCRIPTIONS[tableName] ?? null;
}
